import React, { useEffect, useState } from "react";
import html2canvas from "html2canvas";
import useApi from "../CustomHooks/useApi";
import INDIAN_BANKS from "./indianBanks";

const BENEFICIARY = "SHREE BALAJEE CONNECT PVT LTD";
const PAN         = "ABRCS3396L";
const LOGO_MAP = Object.fromEntries([
  ...INDIAN_BANKS.map((b) => [b.name.toLowerCase(),  b.logo]),
  ...INDIAN_BANKS.map((b) => [b.short.toLowerCase(), b.logo]),
]);

/* ── Tab section icons ─────────────────────────────── */

const CDMIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="4" width="20" height="16" rx="2" />
    <rect x="5" y="7" width="9" height="5" rx="1" />
    <circle cx="18" cy="9"  r="0.8" fill="currentColor" stroke="none" />
    <circle cx="18" cy="12" r="0.8" fill="currentColor" stroke="none" />
    <path d="M5 16h5" />
  </svg>
);

const CashIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="7" width="20" height="10" rx="2" />
    <circle cx="12" cy="12" r="2.5" />
    <path d="M6 12h.01M18 12h.01" strokeWidth={2} />
  </svg>
);

const OnlineIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="9" />
    <path d="M3.6 9h16.8M3.6 15h16.8" />
    <path d="M12 3c-2.8 3.2-4.2 5.9-4.2 9s1.4 5.8 4.2 9" />
    <path d="M12 3c2.8 3.2 4.2 5.9 4.2 9s-1.4 5.8-4.2 9" />
  </svg>
);

const QRCodeIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="7" height="7" rx="1" />
    <rect x="5" y="5" width="3" height="3" fill="currentColor" stroke="none" />
    <rect x="14" y="3" width="7" height="7" rx="1" />
    <rect x="16" y="5" width="3" height="3" fill="currentColor" stroke="none" />
    <rect x="3" y="14" width="7" height="7" rx="1" />
    <rect x="5" y="16" width="3" height="3" fill="currentColor" stroke="none" />
    <path d="M14 14h1v1h-1zM16 14h1v1h-1zM18 14h1v1h-1zM14 16h1v1h-1zM16 16h1v1h-1zM18 16h1v1h-1zM14 18h1v1h-1zM16 18h1v1h-1zM18 18h1v1h-1z" fill="currentColor" stroke="none" />
  </svg>
);

const TABS = [
  { key: "CDM",    label: "CDM",    desc: "Cash Deposit Machine", Icon: CDMIcon,
    active: "bg-blue-600",    light: "bg-blue-50",    text: "text-blue-600",    border: "border-blue-500",    bar: "bg-blue-600"    },
  { key: "CASH",   label: "Cash",   desc: "Cash Deposit Only",    Icon: CashIcon,
    active: "bg-amber-500",   light: "bg-amber-50",   text: "text-amber-600",   border: "border-amber-500",   bar: "bg-amber-500"   },
  { key: "ONLINE", label: "Online", desc: "NEFT / RTGS / IMPS",   Icon: OnlineIcon,
    active: "bg-violet-600",  light: "bg-violet-50",  text: "text-violet-600",  border: "border-violet-500",  bar: "bg-violet-600"  },
  // QR tab disabled — remove this comment and re-add the entry below to bring it back:
  // { key: "QR",     label: "QR",     desc: "QR Payment",           Icon: QRCodeIcon,
  //   active: "bg-emerald-600", light: "bg-emerald-50", text: "text-emerald-600", border: "border-emerald-500", bar: "bg-emerald-600" },
];

/* ── Row icons ─────────────────────────────────────── */

const UserIcon = () => (
  <svg className="w-3.5 h-3.5 text-slate-400 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="8" r="4" />
    <path d="M4 20v-1a8 8 0 0116 0v1" />
  </svg>
);

const CardIcon = () => (
  <svg className="w-3.5 h-3.5 text-slate-400 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="5" width="20" height="14" rx="2" />
    <path d="M2 10h20" />
    <path d="M6 15h4" strokeWidth={2.5} />
  </svg>
);

const BankBuildingIcon = () => (
  <svg className="w-3.5 h-3.5 text-slate-400 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 21h18M3 10h18M12 3L3 10h18L12 3z" />
    <path d="M6 10v11M10 10v11M14 10v11M18 10v11" />
  </svg>
);

const IDCardIcon = () => (
  <svg className="w-3.5 h-3.5 text-slate-400 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="5" width="20" height="14" rx="2" />
    <circle cx="8" cy="12" r="2" />
    <path d="M13 10h5M13 14h3" />
  </svg>
);

const TagIcon = () => (
  <svg className="w-3.5 h-3.5 text-orange-400 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z" />
    <line x1="7" y1="7" x2="7.01" y2="7" strokeWidth={3} />
  </svg>
);

/* ── Banks Page ────────────────────────────────────── */

const Banks = () => {
  const [bankGroups, setBankGroups] = useState([]);
  const [loading,    setLoading]    = useState(false);
  const [activeTab,  setActiveTab]  = useState(null);
  const [feeFilter,  setFeeFilter]  = useState(null);
  const [search,     setSearch]     = useState("");

  const { callApi: getBanks } = useApi("/admin/cashin/banks/grouped", "GET");

  useEffect(() => { fetchBanks(); }, []);

  const fetchBanks = async () => {
    try {
      setLoading(true);
      const res = await getBanks();
      if (Array.isArray(res)) {
        setBankGroups([...res].sort((a, b) => (a.mainBank || "").localeCompare(b.mainBank || "")));
      }
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  const nicksForTab = bankGroups
    .flatMap((g) => (g.nicks || []).filter((n) => n.isActive).map((n) => ({ ...n, mainBank: g.mainBank })))
    .filter((n) => n.sections?.[activeTab]?.isActive);

  const filteredNicks = nicksForTab.filter((n) => {
    const cfg    = n.sections?.[activeTab] || {};
    const hasFee = cfg.feeValue > 0;
    if (feeFilter === "FREE"       && hasFee)  return false;
    if (feeFilter === "CHARGEABLE" && !hasFee) return false;
    if (search) {
      const q = search.toLowerCase();
      return (
        (n.mainBank      || "").toLowerCase().includes(q) ||
        (n.nickName      || "").toLowerCase().includes(q) ||
        (n.accountNumber || "").toLowerCase().includes(q) ||
        (n.ifscCode      || "").toLowerCase().includes(q)
      );
    }
    return true;
  });

  const freeCount       = nicksForTab.filter((n) => !(n.sections?.[activeTab]?.feeValue > 0)).length;
  const chargeableCount = nicksForTab.filter((n) =>   n.sections?.[activeTab]?.feeValue > 0).length;

  const tab = TABS.find((t) => t.key === activeTab);

  if (loading) {
    return (
      <div className="space-y-6 px-1 py-6 sm:p-6">
        <div className="grid grid-cols-4 gap-3">
          {TABS.map((t) => <div key={t.key} className="h-24 bg-slate-100 rounded-2xl animate-pulse" />)}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {[...Array(6)].map((_, i) => (
            <div key={i} className="bg-white rounded-2xl border border-slate-200 p-5 animate-pulse">
              <div className="flex gap-3 mb-4">
                <div className="w-12 h-12 rounded-full bg-slate-100 shrink-0" />
                <div className="flex-1 space-y-2 pt-1">
                  <div className="h-4 bg-slate-100 rounded w-2/3" />
                  <div className="h-3 bg-slate-100 rounded w-1/3" />
                </div>
              </div>
              {[...Array(4)].map((_, j) => <div key={j} className="h-3 bg-slate-100 rounded w-full mb-3" />)}
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6 px-1 py-6 sm:p-6">

      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-xl font-bold text-slate-800">Bank Details</h2>
          <p className="text-xs text-slate-400 mt-0.5">Select deposit type to see available accounts</p>
        </div>
        <button className="flex items-center gap-2 px-4 py-2 rounded-full border border-slate-200 bg-white text-sm font-medium text-slate-600 hover:bg-slate-50 transition-colors shadow-sm">
          <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3" />
            <circle cx="12" cy="17" r="0.5" fill="currentColor" />
          </svg>
          Help Guide
        </button>
      </div>

      {/* Notice */}
      <div className="flex gap-3 sm:gap-4 bg-amber-50 border border-amber-200 rounded-2xl p-3 sm:p-4">
        <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-xl bg-amber-100 flex items-center justify-center shrink-0">
          <svg className="w-4 h-4 sm:w-5 sm:h-5 text-amber-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
            <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
            <line x1="12" y1="9"  x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" strokeWidth={3} />
          </svg>
        </div>
        <div>
          <p className="text-xs font-black text-amber-700 uppercase tracking-wider mb-1">Important Payment Instruction</p>
          <p className="text-xs sm:text-sm text-slate-700 leading-relaxed">
            Online Payments RTGS/NEFT/IMPS/UPI will be accepted only when the payment is made from the{" "}
            <strong>Distributor / Merchant's own bank account</strong>. Payments from any other account{" "}
            <strong className="text-red-500">will not be accepted.</strong>
          </p>
        </div>
      </div>

      {/* Section Tabs */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {TABS.map((t) => {
          const count    = bankGroups
            .flatMap((g) => (g.nicks || []).filter((n) => n.isActive))
            .filter((n) => n.sections?.[t.key]?.isActive).length;
          const isActive = activeTab === t.key;

          return (
            <button
              key={t.key}
              type="button"
              onClick={() => { setActiveTab(t.key); setFeeFilter(null); setSearch(""); }}
              className={`flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-3 p-3 sm:p-4 rounded-2xl border-2 bg-white text-left transition-all hover:shadow-sm ${
                isActive ? `${t.border} shadow-sm` : "border-slate-200 hover:border-slate-300"
              }`}>
              <div className={`w-9 h-9 sm:w-12 sm:h-12 rounded-xl ${t.light} flex items-center justify-center shrink-0`}>
                <t.Icon className={`w-4 h-4 sm:w-6 sm:h-6 ${t.text}`} />
              </div>
              <div className="flex-1 min-w-0">
                <p className={`text-xs sm:text-sm font-black leading-tight ${isActive ? t.text : "text-slate-700"}`}>{t.label}</p>
                <p className="text-[10px] text-slate-400 leading-tight mt-0.5">{t.desc}</p>
                <div className="flex items-center gap-1.5 mt-1.5 sm:mt-2">
                  <span className={`min-w-[1.25rem] sm:min-w-[1.5rem] h-5 sm:h-6 px-1.5 rounded-full ${t.active} flex items-center justify-center text-white text-[10px] font-black`}>
                    {count}
                  </span>
                  <span className="text-[10px] text-slate-400">Accounts</span>
                </div>
              </div>
            </button>
          );
        })}
      </div>

      {/* Filter + Search row */}
      {activeTab !== null && <div className="flex flex-wrap items-center gap-3">
        <span className="text-xs text-slate-500 font-semibold shrink-0">Filter:</span>

        {[
          { key: "ALL",        label: "All",        count: nicksForTab.length },
          { key: "FREE",       label: "Free",       count: freeCount          },
          { key: "CHARGEABLE", label: "Chargeable", count: chargeableCount    },
        ].map((f) => (
          <button
            key={f.key}
            type="button"
            onClick={() => setFeeFilter(f.key)}
            className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-bold border-2 transition-all ${
              feeFilter === f.key
                ? `${tab.active} border-transparent text-white shadow-sm`
                : `bg-white ${tab.border} ${tab.text}`
            }`}>
            {f.label}
            <span className={`text-xs font-black ${feeFilter === f.key ? "text-white/80" : ""}`}>{f.count}</span>
          </button>
        ))}

        {/* Search */}
        <div className="w-full sm:w-80 sm:ml-auto flex items-center gap-2 bg-white border border-slate-200 rounded-full px-4 py-2.5 focus-within:border-slate-400 transition-colors">
          <svg className="w-4 h-4 text-slate-400 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-4.35-4.35M17 11A6 6 0 111 11a6 6 0 0116 0z" />
          </svg>
          <input
            type="text"
            placeholder="Search by bank name, account no, IFSC..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="flex-1 text-sm outline-none text-slate-700 placeholder-slate-400 bg-transparent min-w-0"
          />
        </div>

        {/* Sliders / filter icon */}
        <button className="w-10 h-10 rounded-full border border-slate-200 bg-white flex items-center justify-center text-slate-500 hover:bg-slate-50 hover:text-slate-700 transition-colors shrink-0 shadow-sm">
          <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
            <line x1="4"  y1="6"  x2="20" y2="6"  />
            <line x1="4"  y1="12" x2="20" y2="12" />
            <line x1="4"  y1="18" x2="20" y2="18" />
            <circle cx="8"  cy="6"  r="2" fill="white" />
            <circle cx="16" cy="12" r="2" fill="white" />
            <circle cx="10" cy="18" r="2" fill="white" />
          </svg>
        </button>
      </div>}

      {/* Bank Cards */}
      {feeFilter !== null && (filteredNicks.length === 0 ? (
        <div className="bg-white rounded-2xl border border-slate-200 py-16 text-center">
          <p className="text-slate-400 text-sm">No banks available for this filter.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {filteredNicks.map((nick) => (
            <BankCard key={`${nick.id}-${activeTab}`} nick={nick} tab={tab} />
          ))}
        </div>
      ))}
    </div>
  );
};

/* ── Bank Card ─────────────────────────────────────── */

const BankCard = ({ nick, tab }) => {
  const [copied,   setCopied]   = useState(null);
  const [expanded, setExpanded] = useState(false);
  const [sharing,  setSharing]  = useState(false);

  const secCfg       = nick.sections?.[tab.key] || {};
  const hasFee       = secCfg.feeValue > 0;
  const hasTpFee     = secCfg.tpFeeValue > 0;
  const feeDisplay   = hasFee
    ? secCfg.feeType === "PERCENTAGE" ? `${secCfg.feeValue}%` : `₹${secCfg.feeValue}`
    : "Free";
  const tpFeeDisplay = hasTpFee
    ? secCfg.tpFeeType === "PERCENTAGE" ? `${secCfg.tpFeeValue}%` : `₹${secCfg.tpFeeValue}`
    : "";
  const logo = LOGO_MAP[(nick.mainBank || "").toLowerCase()];

  const copy = (value, field) => {
    navigator.clipboard.writeText(value);
    setCopied(field);
    setTimeout(() => setCopied(null), 1500);
  };

  // Build a clean, off-screen template with the FULL details (no truncation / clipping)
  const buildShareNode = () => {
    const colorMap = {
      CDM:    { bar: "#2563eb", light: "#eff6ff", text: "#1d4ed8", badge: "#dbeafe" },
      CASH:   { bar: "#f59e0b", light: "#fffbeb", text: "#b45309", badge: "#fef3c7" },
      ONLINE: { bar: "#7c3aed", light: "#f5f3ff", text: "#6d28d9", badge: "#ede9fe" },
      QR:     { bar: "#059669", light: "#ecfdf5", text: "#047857", badge: "#d1fae5" },
    };
    const clr = colorMap[tab.key] || colorMap.CDM;

    const now = new Date();
    const timeStr = now.toLocaleString("en-IN", {
      day: "2-digit", month: "short", year: "numeric",
      hour: "2-digit", minute: "2-digit", hour12: true,
    });

    const fmtAcct = (num) => (num || "").replace(/(.{4})/g, "$1 ").trim();
    const displayAcct = tab.key === "QR"
      ? `XXXX XXXX XXXX ${(nick.accountNumber || "").slice(-4)}`
      : fmtAcct(nick.accountNumber);

    const logoHtml = logo
      ? `<div style="width:56px;height:56px;border-radius:14px;border:1.5px solid #e2e8f0;background:#fff;display:flex;align-items:center;justify-content:center;overflow:hidden;padding:6px;flex-shrink:0;box-shadow:0 1px 4px rgba(0,0,0,0.08);">
           <img src="${logo}" crossorigin="anonymous" style="width:100%;height:100%;object-fit:contain;" />
         </div>`
      : `<div style="width:56px;height:56px;border-radius:14px;background:${clr.bar};display:flex;align-items:center;justify-content:center;color:#fff;font-size:22px;font-weight:800;flex-shrink:0;box-shadow:0 1px 4px rgba(0,0,0,0.15);">${(nick.mainBank || "B")[0]}</div>`;

    const node = document.createElement("div");
    node.style.cssText = "position:fixed;left:-9999px;top:0;width:390px;background:#f8fafc;font-family:system-ui,-apple-system,'Segoe UI',Roboto,sans-serif;";
    node.innerHTML = `

      <!-- Nav Bar -->
      <div style="background:${clr.bar};padding:12px 20px 30px;display:flex;align-items:center;gap:12px;">
        <div style="width:32px;height:32px;border-radius:50%;background:rgba(255,255,255,0.15);display:flex;align-items:center;justify-content:center;">
          <svg width="16" height="16" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6"/></svg>
        </div>
        <div style="flex:1;">
          <div style="color:white;font-size:16px;font-weight:800;letter-spacing:-0.01em;">Bank Details</div>
          <div style="color:rgba(255,255,255,0.75);font-size:11px;margin-top:1px;">${tab.label} · ${tab.desc}</div>
        </div>
        <span style="background:rgba(255,255,255,0.2);color:white;font-size:11px;font-weight:700;padding:4px 10px;border-radius:20px;letter-spacing:0.04em;">${tab.key}</span>
      </div>

      <!-- Card -->
      <div style="margin:-10px 16px 0;background:white;border-radius:20px;overflow:hidden;box-shadow:0 4px 24px rgba(0,0,0,0.10);">

        <!-- Bank Header -->
        <div style="padding:20px 20px 16px;">
          <div style="display:flex;align-items:center;gap:14px;">
            ${logoHtml}
            <div style="flex:1;min-width:0;">
              <div style="font-size:17px;font-weight:800;color:#0f172a;line-height:1.3;">${nick.mainBank || ""}</div>
              <div style="font-size:12px;color:#94a3b8;margin-top:3px;">${nick.nickName || ""}</div>
              <div style="font-size:12px;font-weight:700;color:${clr.bar};margin-top:5px;">${tab.desc}</div>
            </div>
          </div>
        </div>

        <div style="height:1px;background:#f1f5f9;margin:0 20px;"></div>

        <!-- Beneficiary -->
        <div style="padding:14px 20px;border-bottom:1px solid #f1f5f9;">
          <div style="font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:0.08em;color:#94a3b8;margin-bottom:5px;">Beneficiary Name</div>
          <div style="font-size:14px;font-weight:700;color:#0f172a;">${BENEFICIARY}</div>
        </div>

        <!-- Account number: spaced like a financial instrument -->
        <div style="padding:14px 20px;background:#f8fafc;border-bottom:1px solid #f1f5f9;">
          <div style="font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:0.08em;color:#94a3b8;margin-bottom:6px;">Account Number</div>
          <div style="font-size:18px;font-weight:800;color:#0f172a;letter-spacing:0.12em;font-variant-numeric:tabular-nums;">${displayAcct}</div>
        </div>

        ${tab.key !== "QR" ? `
        <!-- IFSC + Branch: two columns -->
        <div style="display:flex;border-bottom:1px solid #f1f5f9;">
          <div style="flex:1;padding:14px 20px;border-right:1px solid #f1f5f9;">
            <div style="font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:0.08em;color:#94a3b8;margin-bottom:5px;">IFSC Code</div>
            <div style="font-size:14px;font-weight:700;color:#0f172a;letter-spacing:0.05em;">${nick.ifscCode || "—"}</div>
          </div>
          <div style="flex:1;padding:14px 20px;">
            <div style="font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:0.08em;color:#94a3b8;margin-bottom:5px;">Branch / Bank</div>
            <div style="font-size:14px;font-weight:700;color:#0f172a;">${nick.mainBank || "—"}</div>
          </div>
        </div>
        ` : ""}

        <!-- PAN -->
        <div style="padding:14px 20px;">
          <div style="font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:0.08em;color:#94a3b8;margin-bottom:5px;">PAN Number</div>
          <div style="font-size:14px;font-weight:700;color:#0f172a;letter-spacing:0.06em;">${PAN}</div>
        </div>

      </div>

      <!-- Footer -->
      <div style="padding:14px 20px 24px;display:flex;align-items:center;justify-content:space-between;">
        <div style="display:flex;align-items:center;gap:6px;">
          <div style="width:20px;height:20px;border-radius:6px;background:${clr.bar};display:flex;align-items:center;justify-content:center;">
            <svg width="12" height="12" fill="white" viewBox="0 0 24 24"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></svg>
          </div>
          <span style="font-size:12px;font-weight:700;color:#64748b;letter-spacing:0.01em;">Shree Balajee Connect Pvt Ltd</span>
        </div>
        <span style="font-size:10px;color:#94a3b8;">${timeStr}</span>
      </div>`;
    return node;
  };

  const share = async () => {
    if (sharing) return;

    let node;
    try {
      setSharing(true);

      node = buildShareNode();
      document.body.appendChild(node);

      // Wait for the logo image to finish loading so it isn't missing in the capture
      await Promise.all(
        Array.from(node.querySelectorAll("img")).map((img) =>
          img.complete ? Promise.resolve() : new Promise((res) => { img.onload = img.onerror = res; })
        )
      );

      const canvas = await html2canvas(node, {
        scale: 3,
        useCORS: true,
        backgroundColor: "#f8fafc",
        logging: false,
      });

      const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/png"));
      if (!blob) return;

      const fileName = `${(nick.mainBank || "bank").replace(/\s+/g, "-")}-details.png`;
      const file = new File([blob], fileName, { type: "image/png" });

      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({ files: [file], title: nick.mainBank });
      } else {
        // Fallback: download the image
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(url);
      }
    } catch (e) {
      /* user cancelled share — no-op */
    } finally {
      if (node && node.parentNode) node.parentNode.removeChild(node);
      setSharing(false);
    }
  };

  const Row = ({ label, value, icon, copyable = false, noTruncate = false }) => (
    <div className="flex items-center gap-2.5 py-2.5 border-b border-slate-100 last:border-0">
      {icon}
      <span className="text-xs text-slate-400 w-24 shrink-0">{label}</span>
      <div className="flex items-center justify-end flex-1 min-w-0 gap-1.5">
        <span className={`text-xs font-bold text-slate-800 text-right ${noTruncate ? "break-all" : "truncate"}`}>{value || "—"}</span>
        {copyable && value && value !== "—" && (
          <button onClick={() => copy(value, label)} className="shrink-0" title="Copy">
            {copied === label ? (
              <svg className="w-3.5 h-3.5 text-emerald-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            ) : (
              <svg className="w-3.5 h-3.5 text-slate-300 hover:text-slate-500 transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
              </svg>
            )}
          </button>
        )}
      </div>
    </div>
  );

  return (
    <div className="bg-white rounded-2xl border border-slate-200 shadow-sm hover:shadow-md transition-shadow overflow-hidden flex flex-col">

      {/* Colored top bar */}
      <div className={`h-1.5 w-full ${tab.bar}`} />

      <div className="p-5 flex-1">

        {/* Card header */}
        <div className="flex items-center gap-3 mb-4">
          {logo ? (
            <div className="w-12 h-12 rounded-full border border-slate-100 bg-white flex items-center justify-center overflow-hidden p-1 shrink-0 shadow-sm">
              <img
                src={logo}
                alt={nick.mainBank}
                className="w-full h-full object-contain"
                onError={(e) => {
                  e.target.style.display = "none";
                  e.target.parentNode.className = `w-12 h-12 rounded-full ${tab.active} flex items-center justify-center shrink-0`;
                  e.target.parentNode.innerHTML = `<span class="text-white text-base font-black">${(nick.mainBank || "B")[0]}</span>`;
                }}
              />
            </div>
          ) : (
            <div className={`w-12 h-12 rounded-full ${tab.active} flex items-center justify-center text-white text-base font-black shrink-0`}>
              {(nick.mainBank || "B")[0]}
            </div>
          )}

          <div className="flex-1 min-w-0">
            <p className="text-sm font-black text-slate-800 leading-tight truncate">{nick.mainBank}</p>
            <p className="text-[11px] text-slate-400 mt-0.5 truncate">{nick.nickName}</p>
          </div>

          <span className={`text-xs font-bold shrink-0 ${
            hasFee
              ? "bg-red-50 text-red-500 border border-red-100 px-2.5 py-1 rounded-full"
              : "text-emerald-600 font-black"
          }`}>
            {feeDisplay}
          </span>

          <button
            onClick={share}
            disabled={sharing}
            title="Share bank details"
            className="shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-slate-400 hover:text-blue-600 hover:bg-blue-50 transition-colors disabled:opacity-60">
            {sharing ? (
              <svg className="w-4 h-4 animate-spin text-blue-600" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth={4} />
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
              </svg>
            ) : (
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
              </svg>
            )}
          </button>
        </div>

        {/* Info rows */}
        <Row label="Beneficiary" value={BENEFICIARY}  icon={<UserIcon />} />
        <Row
          label="Account No"
          value={tab.key === "QR"
            ? `•••• ${(nick.accountNumber || "").slice(-4)}`
            : nick.accountNumber}
          icon={<CardIcon />}
          noTruncate
        />
        {tab.key !== "QR" && (
          <Row label="IFSC" value={nick.ifscCode} icon={<BankBuildingIcon />} />
        )}
        <Row label="PAN" value={PAN} icon={<IDCardIcon />} />

      </div>

      {/* Fee details — always visible */}
      <div className="px-5 pb-4 pt-3 border-t border-slate-100 space-y-2">
        <div className="flex items-center justify-between">
          <span className="text-xs text-slate-400">Fee Type</span>
          <span className={`text-[10px] font-black px-2 py-0.5 rounded-full ${
            secCfg.feeType === "PERCENTAGE" ? "bg-purple-100 text-purple-700" : "bg-blue-100 text-blue-700"
          }`}>{secCfg.feeType || "FLAT"}</span>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-xs text-slate-400">Service Fee</span>
          <span className={`text-xs font-black ${hasFee ? "text-red-500" : "text-emerald-600"}`}>{feeDisplay}</span>
        </div>
        <div className="border-t border-slate-200 pt-2 mt-1 flex items-center justify-between">
          <span className="text-xs text-slate-400">Out of Zone Charge Type</span>
          <span className={`text-[10px] font-black px-2 py-0.5 rounded-full ${
            secCfg.tpFeeType === "PERCENTAGE" ? "bg-orange-100 text-orange-700" : "bg-teal-100 text-teal-700"
          }`}>{secCfg.tpFeeType || "FLAT"}</span>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-xs text-slate-400">Out of Zone Charges</span>
          <span className={`text-xs font-black ${hasTpFee ? "text-orange-500" : "text-emerald-600"}`}>
            {hasTpFee ? tpFeeDisplay : "Free"}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Banks;
